import React from 'react';
import { useTranslation } from 'react-i18next';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

import { useLanguageContext } from '@lumirental/lumi-web-shared/lib/contexts/Language.context';

import NavigateForwardIcon from '@/components/Icons/NavigateForward';

import styles from '@/components/BreadCrumb/BreadCrumb.style';

const useStyles = makeStyles()(styles);

export default function BreadCrumb({ currentPage }) {
  const { classes } = useStyles();
  // const router = useRouter();
  const { t } = useTranslation();

  const { language } = useLanguageContext();

  const goToHomePage = () => {
    // navigateAndScrollToTop(router, '');
  };

  return (
    <div className={classes.breadCrumbs}>
      <List component="ul" className={classes.breadCrumbList}>
        <ListItem className={classes.breadCrumbItem}>
          <Typography
            component="a"
            className={classes.breadCrumbLink}
            onClick={goToHomePage}
          >
            {t('home')}
          </Typography>
          <NavigateForwardIcon language={language} />
        </ListItem>
        <ListItem className={classes.breadCrumbItem}>
          <Typography component="span" className={classes.breadCrumbText}>
            {currentPage}
          </Typography>
        </ListItem>
      </List>
    </div>
  );
}
